module.exports = __webpack_public_path__ + "img/centralFileBackup.7d438ec0.svg";